export default () => {
  $('.mobile-menu-navigation__trigger').on('click', function (evt) {
    evt.preventDefault();

    $('.main-menu .mobile-menu-navigation__trigger').removeClass('is-active').addClass('is-disabled');
    $('.main-menu ul').removeClass('is-active');

    $('.main-menu').toggleClass('is-active');
  });
}



// WEBPACK FOOTER //
// ./themes/app/assets/js/modules/mobileMenu.js